import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-blacklists',
  templateUrl: './admin-blacklists.component.html',
  styleUrls: ['./admin-blacklists.component.css']
})
export class AdminBlacklistsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/admin-blacklists/admin-blacklists.component.ts